export default {
    message: {
        impersonation: "Estás realizando el pedido en nombre de «{name}»"
    }
}